<div *ngIf="!continueClicked" class="center-block text-center">
  <h3>Unable to find page "{{missingPage}}".</h3>
  <button (click)="continue()" class="btn btn-primary">Go to Main Page</button>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/page-not-found.component.html